import bookmarksReducer from './bookmarksSlice';
import notificationsReducer from './notificationsSlice';

export default {
    bookmarks: bookmarksReducer,
    notifications: notificationsReducer,
};
